import { MONETIZATION_STATUSES } from '@nerdwallet/marketplace/constants';
import { isNonMonetizing } from '@nerdwallet/marketplace/selectors/common';

/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/utils/format` directly.
 */
export { getPercentageRange, formatTwoDecimals } from '@nerdwallet/marketplace/utils/format';

/**
 * Provide a utility for knowing when in the server
 *
 * @return {boolean} - The value if this is fact from server side or not.
 */
export var isServer = function isServer() {
  return !(typeof window !== 'undefined' && window.document);
};

/**
 *
 * @param {Object} marketplaceEntity  the marketplace entity object
 *
 * @return {String}   the expected shopping finished event monetizable string
 * One of 'yes_assumed',
 *        'no',
 *        'no_because_of_limit',
 *        'no_because_of_lead',
 */
export var getMonetizable = function getMonetizable(marketplaceEntity) {
  return isNonMonetizing(marketplaceEntity) ? MONETIZATION_STATUSES.NO : MONETIZATION_STATUSES.YES_ASSUMED;
};